import { Button } from "antd";
import { useState } from "react";
import { useToken } from "../../../hooks/useToken";
import { useTheme } from "../../../providers/ThemeProvider";
import { formatDate } from "../../../utils/date";
import { Card } from "../../card";
import { ModalPostNew } from "../../timeline/ModalPostNew";

export function CreateEventFunction({ args }: { args: any }) {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [isCreated, setCreated] = useState<boolean>(false);
  const { token } = useToken();
  const { theme } = useTheme();

  return (
    <>
      {isOpen && (
        <ModalPostNew
          suggest={{
            date: args.eventDate || formatDate(new Date()),
            title: args.title,
            text: args.text,
            location: args.location,
          }}
          onClose={() => setOpen(false)}
          onCreate={() => {
            setCreated(true);
            setOpen(false);
          }}
        />
      )}

      <Card
        modelStyle="OLD"
        model={{
          title: true,
          description: true,
        }}
        cardIcon={
          <img
            src={theme == "DARK" ? "/icon-light.svg" : "/icon-dark.svg"}
            alt="Icon"
          />
        }
        cardTitle={args.eventDate || formatDate(new Date())}
        title={args.title}
        description={args.text}
      />
      <Button
        disabled={isCreated}
        type="primary"
        style={{
          marginTop: token.margin,
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        Review
      </Button>
    </>
  );
}
